/**
 * Monte Seu Kit — Wizard multi-step
 * Gerencia seleção de kit, produtos por slot, personalização via drawer e envio ao carrinho.
 */

(function () {
  'use strict';

  // =====================================================
  // Estado global
  // =====================================================
  var state = {
    kitId: null,
    kitNome: '',
    kitConfig: {
      qtyCanetas: 0,
      qtyCarteiras: 0,
    },
    selections: {},  // { 'caneta-1': { slotKey, type, variantId, title, price, imageUrl, personalization } }
    stepSequence: ['kit'],
    currentStepIndex: 0,
    mensagem: { para: '', texto: '' },
  };

  var rootEl = null;
  var showPenFilters = false;

  // Slot ativo no drawer de personalização (PDP snippet)
  var currentPPSlot = null;

  // Estado do modal de seleção de variante
  var variantModalState = {
    slotKey: null,
    card: null,
    selectedVariantData: null,
    selectedOptions: {},
    numOptions: 0,
  };

  // =====================================================
  // Init
  // =====================================================
  function init() {
    rootEl = document.querySelector('.mskit');
    if (!rootEl) return;

    showPenFilters = rootEl.dataset.showPenFilters === 'true';

    bindKitCards();
    bindNavButtons();
    bindMessageStep();
    bindFilters();
    bindVariantModal();

    renderProgress();
    activateStep(0);
  }

  // =====================================================
  // Navegação
  // =====================================================
  function activateStep(index) {
    state.currentStepIndex = index;
    var stepKey = state.stepSequence[index];

    rootEl.querySelectorAll('.mskit__step').forEach(function (el) {
      el.classList.remove('mskit__step--active');
    });

    var activeEl = rootEl.querySelector('[data-step="' + stepKey + '"]');
    if (activeEl) {
      activeEl.classList.add('mskit__step--active');
      var top = activeEl.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    if (stepKey === 'resumo') buildSummary();

    renderProgress();
    updateNavButtons();
  }

  function nextStep() {
    if (state.currentStepIndex < state.stepSequence.length - 1) {
      activateStep(state.currentStepIndex + 1);
    }
  }

  function prevStep() {
    if (state.currentStepIndex > 0) {
      activateStep(state.currentStepIndex - 1);
    }
  }

  // =====================================================
  // Progresso
  // =====================================================
  function renderProgress() {
    var container = rootEl.querySelector('.mskit__progress');
    if (!container) return;

    container.innerHTML = '';
    state.stepSequence.forEach(function (key, idx) {
      var isActive = idx === state.currentStepIndex;
      var isCompleted = idx < state.currentStepIndex;

      var stepEl = document.createElement('div');
      stepEl.className = 'mskit__progress-step' +
        (isActive ? ' active' : '') +
        (isCompleted ? ' completed' : '');

      var dot = document.createElement('div');
      dot.className = 'mskit__progress-dot';
      dot.textContent = isCompleted ? '✓' : String(idx + 1);

      var label = document.createElement('div');
      label.className = 'mskit__progress-label';
      label.textContent = getStepLabel(key);

      stepEl.appendChild(dot);
      stepEl.appendChild(label);
      container.appendChild(stepEl);
    });
  }

  function getStepLabel(key) {
    var labels = {
      kit: 'Kit',
      mensagem: 'Mensagem',
      resumo: 'Resumo',
    };
    if (labels[key]) return labels[key];
    if (key.startsWith('caneta-')) return 'Caneta ' + key.split('-')[1];
    if (key.startsWith('carteira-')) return 'Carteira ' + key.split('-')[1];
    return key;
  }

  // =====================================================
  // Barra de navegação fixa
  // =====================================================
  function updateNavButtons() {
    var stepKey = state.stepSequence[state.currentStepIndex];
    var canGo = canAdvance(stepKey);
    var isFirst = state.currentStepIndex === 0;

    // Barra fixa
    var bottomBar = document.getElementById('mskit-bottom-bar');
    var backBtn = document.getElementById('mskit-back-btn');
    var nextBtn = document.getElementById('mskit-next-btn');
    var personalizeBtn = document.getElementById('mskit-personalize-btn');

    if (bottomBar) bottomBar.style.display = isFirst ? 'none' : 'flex';
    if (backBtn) backBtn.style.visibility = isFirst ? 'hidden' : 'visible';

    if (nextBtn) {
      if (stepKey === 'resumo') {
        nextBtn.textContent = 'Adicionar ao Carrinho';
        nextBtn.disabled = false;
      } else {
        nextBtn.textContent = 'Continuar →';
        nextBtn.disabled = !canGo;
      }
    }

    if (personalizeBtn) {
      var isCanetaStep = stepKey.startsWith('caneta-');
      var hasSelection = isCanetaStep && !!state.selections[stepKey] && !!state.selections[stepKey].personalizable;
      personalizeBtn.style.display = hasSelection ? '' : 'none';
      if (hasSelection) {
        var pp = state.selections[stepKey].personalization;
        personalizeBtn.textContent = (pp && pp.texto && pp.texto.trim()) ? 'Personalizado ✓' : 'Personalizar';
      }
    }

    // Botões inline dentro do step ativo
    var stepEl = rootEl.querySelector('[data-step="' + stepKey + '"]');
    if (stepEl) {
      var inlineBack = stepEl.querySelector('[data-mskit-action="back"]');
      var inlineNext = stepEl.querySelector('[data-mskit-action="next"]');
      if (inlineBack) inlineBack.style.visibility = isFirst ? 'hidden' : 'visible';
      if (inlineNext && stepKey !== 'resumo') inlineNext.disabled = !canGo;
    }
  }

  function canAdvance(stepKey) {
    if (stepKey === 'kit') return !!state.kitId;
    if (stepKey === 'mensagem') return true;
    if (stepKey === 'resumo') return true;
    return !!state.selections[stepKey];
  }

  function bindNavButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mskit-action]');
      if (!btn) return;

      var action = btn.dataset.mskitAction;
      if (action === 'back') {
        prevStep();
      } else if (action === 'next' && !btn.disabled) {
        var stepKey = state.stepSequence[state.currentStepIndex];
        if (stepKey === 'resumo') {
          submitToCart();
        } else {
          nextStep();
        }
      } else if (action === 'personalize') {
        var currentStep = state.stepSequence[state.currentStepIndex];
        openPersonalizeDrawer(currentStep);
      }
    });
  }

  // =====================================================
  // Step 1: Seleção de kit
  // =====================================================
  function bindKitCards() {
    rootEl.querySelectorAll('.mskit__kit-card').forEach(function (card) {
      card.addEventListener('click', function () {
        onKitSelected(this);
      });
    });
  }

  function onKitSelected(card) {
    rootEl.querySelectorAll('.mskit__kit-card').forEach(function (c) {
      c.classList.remove('mskit__kit-card--selected');
    });
    card.classList.add('mskit__kit-card--selected');

    state.kitId = card.dataset.kitId;
    state.kitNome = card.dataset.nome || '';
    state.kitConfig.qtyCanetas   = parseInt(card.dataset.qtyCanetas  || '0', 10);
    state.kitConfig.qtyCarteiras = parseInt(card.dataset.qtyCarteiras || '0', 10);

    buildStepSequence();
    updateNavButtons();
    nextStep();
  }

  function buildStepSequence() {
    var seq = ['kit'];
    for (var i = 1; i <= state.kitConfig.qtyCanetas;   i++) seq.push('caneta-'   + i);
    for (var k = 1; k <= state.kitConfig.qtyCarteiras; k++) seq.push('carteira-' + k);
    seq.push('mensagem');
    seq.push('resumo');

    state.stepSequence = seq;
    state.selections = {};

    buildDynamicSteps();
    renderProgress();
  }

  // =====================================================
  // Filtros de caneta
  // =====================================================
  function buildFilterBarHTML(slotKey) {
    return (
      '<div class="mskit__filters" data-filters-slot="' + slotKey + '">' +
        '<button class="mskit__filter-btn mskit__filter-btn--active" data-filter="all" data-filter-slot="' + slotKey + '">Todos</button>' +
        '<button class="mskit__filter-btn" data-filter="esferografica" data-filter-slot="' + slotKey + '">Esferográfica</button>' +
        '<button class="mskit__filter-btn" data-filter="rollerball" data-filter-slot="' + slotKey + '">Rollerball</button>' +
        '<button class="mskit__filter-btn" data-filter="tinteiro" data-filter-slot="' + slotKey + '">Tinteiro</button>' +
      '</div>'
    );
  }

  function applyFilter(slotKey, filter) {
    var grid = rootEl.querySelector('.mskit__slot-grid[data-slot="' + slotKey + '"]');
    if (!grid) return;
    grid.querySelectorAll('.mskit__product-card').forEach(function (card) {
      if (filter === 'all') {
        card.style.display = '';
      } else {
        var types = (card.dataset.productTypes || '').split(',').map(function (t) { return t.trim(); });
        card.style.display = types.indexOf(filter) !== -1 ? '' : 'none';
      }
    });
  }

  function bindFilters() {
    rootEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter-slot]');
      if (!btn) return;
      var filter = btn.dataset.filter;
      var slotKey = btn.dataset.filterSlot;
      if (!filter || !slotKey) return;

      var filterBar = btn.closest('.mskit__filters');
      if (filterBar) {
        filterBar.querySelectorAll('.mskit__filter-btn').forEach(function (b) {
          b.classList.remove('mskit__filter-btn--active');
        });
        btn.classList.add('mskit__filter-btn--active');
      }

      applyFilter(slotKey, filter);
    });
  }

  // =====================================================
  // Steps dinâmicos (produto por slot)
  // =====================================================
  function buildDynamicSteps() {
    var container = rootEl.querySelector('.mskit__dynamic-steps');
    if (!container) return;
    container.innerHTML = '';

    state.stepSequence.forEach(function (key) {
      if (['kit', 'mensagem', 'resumo'].indexOf(key) !== -1) return;

      var type = key.split('-')[0];   // 'caneta' | 'carteira'
      var num  = key.split('-')[1];
      var typeLabel = { caneta: 'Caneta', carteira: 'Carteira' }[type] || type;
      var sourceId = 'mskit-products-' + state.kitId + '-' + type + 's';
      var sourceGrid = document.getElementById(sourceId);

      var gridHTML = sourceGrid
        ? sourceGrid.innerHTML
        : '<div class="mskit__no-products">Configure a coleção de ' + typeLabel.toLowerCase() + 's nas configurações da seção.</div>';

      var filterBarHTML = (type === 'caneta' && showPenFilters) ? buildFilterBarHTML(key) : '';
      var artigo = type === 'caneta' ? 'a' : 'o';
      var artigoIndef = type === 'caneta' ? 'uma' : 'um';

      var stepEl = document.createElement('div');
      stepEl.className = 'mskit__step';
      stepEl.dataset.step = key;
      stepEl.innerHTML =
        '<div class="mskit__step-title">Escolha ' + artigo + ' ' + typeLabel.toLowerCase() + ' ' + num + '</div>' +
        '<p class="mskit__step-subtitle">Selecione ' + artigoIndef + ' ' + typeLabel.toLowerCase() + ' para o seu kit.</p>' +
        filterBarHTML +
        '<div class="mskit__products-grid mskit__slot-grid" data-slot="' + key + '">' +
          gridHTML +
        '</div>' +
        '<div class="mskit__nav">' +
          '<button class="mskit__btn mskit__btn--ghost" data-mskit-action="back">← Voltar</button>' +
          '<button class="mskit__btn mskit__btn--primary" data-mskit-action="next" disabled>Continuar →</button>' +
        '</div>';

      container.appendChild(stepEl);
    });

    bindProductCards();
  }

  // =====================================================
  // Seleção de produtos
  // =====================================================
  function bindProductCards() {
    rootEl.querySelectorAll('.mskit__slot-grid .mskit__product-card').forEach(function (card) {
      if (card.dataset.mskitBound) return;
      card.dataset.mskitBound = '1';
      card.addEventListener('click', function () {
        var grid = this.closest('.mskit__slot-grid');
        if (!grid) return;
        var slotKey = grid.dataset.slot;
        if (this.dataset.hasVariants === 'true') {
          openVariantModal(slotKey, this);
        } else {
          onProductSelected(slotKey, this);
        }
      });
    });
  }

  function onProductSelected(slotKey, card, overrideData) {
    var grid = card.closest('.mskit__products-grid, .mskit__slot-grid');
    if (grid) {
      grid.querySelectorAll('.mskit__product-card').forEach(function (c) {
        c.classList.remove('mskit__product-card--selected');
      });
    }
    card.classList.add('mskit__product-card--selected');

    var type = slotKey.startsWith('caneta') ? 'caneta' : 'carteira';

    var variantId    = overrideData ? overrideData.variantId    : card.dataset.variantId;
    var title        = overrideData ? overrideData.title        : (card.dataset.productTitle || '');
    var price        = overrideData ? overrideData.price        : (card.dataset.productPrice || '');
    var imageUrl     = overrideData ? overrideData.imageUrl     : (card.dataset.productImage || '');
    var variantLabel = overrideData ? (overrideData.variantLabel || '') : '';
    var productId    = card.dataset.productId || '';
    var personalizable = card.dataset.personalizable === 'true';

    // Preservar personalização apenas se o produto for o mesmo
    var prevSel = state.selections[slotKey];
    var existingPersonalization = (prevSel && prevSel.productId === productId)
      ? prevSel.personalization
      : null;

    state.selections[slotKey] = {
      slotKey: slotKey,
      type: type,
      variantId: variantId,
      productId: productId,
      personalizable: personalizable,
      title: title,
      price: price,
      imageUrl: imageUrl,
      variantLabel: variantLabel,
      personalization: existingPersonalization,
    };

    if (overrideData) {
      var cardImg = card.querySelector('.mskit__product-img');
      if (cardImg && imageUrl) cardImg.src = imageUrl;
      var cardPrice = card.querySelector('.mskit__product-price');
      if (cardPrice && price) cardPrice.textContent = price;
      var badge = card.querySelector('.mskit__product-variant-badge');
      if (!badge && variantLabel) {
        badge = document.createElement('div');
        badge.className = 'mskit__product-variant-badge';
        var info = card.querySelector('.mskit__product-info');
        if (info) info.appendChild(badge);
      }
      if (badge) badge.textContent = variantLabel;
    }

    updateNavButtons();
  }

  // =====================================================
  // Modal de seleção de variante
  // =====================================================
  function openVariantModal(slotKey, card) {
    var productData;
    try { productData = JSON.parse(card.dataset.productData || '{}'); } catch (e) {
      onProductSelected(slotKey, card);
      return;
    }
    var variants = productData.variants || [];
    var options  = productData.options  || [];
    if (!variants.length) { onProductSelected(slotKey, card); return; }

    variantModalState.slotKey            = slotKey;
    variantModalState.card               = card;
    variantModalState.selectedVariantData = null;
    variantModalState.selectedOptions    = {};
    variantModalState.numOptions         = options.length;

    var modal = document.getElementById('mskit-variant-modal');
    if (!modal) { onProductSelected(slotKey, card); return; }

    var titleEl = document.getElementById('mskit-variant-modal-title');
    if (titleEl) titleEl.textContent = card.dataset.productTitle || '';

    var imgEl = document.getElementById('mskit-variant-modal-image');
    if (imgEl) {
      imgEl.src = card.dataset.productImage || '';
      imgEl.alt = card.dataset.productTitle || '';
    }

    renderModalOptions(productData);

    var confirmBtn = document.getElementById('mskit-variant-modal-confirm');
    if (confirmBtn) confirmBtn.disabled = true;

    var priceEl = document.getElementById('mskit-variant-modal-price');
    if (priceEl) priceEl.textContent = card.dataset.productPrice || '';

    var personalizarBtn = document.getElementById('mskit-variant-modal-personalizar');
    if (personalizarBtn) {
      personalizarBtn.style.display = card.dataset.personalizable === 'true' ? '' : 'none';
      personalizarBtn.disabled = true;
    }

    var optContainer = document.getElementById('mskit-variant-modal-options');
    if (optContainer) {
      optContainer.querySelectorAll('.mskit__variant-modal__option-btns').forEach(function (btns) {
        var firstBtn = btns.querySelector('.mskit__variant-modal__option-btn');
        if (firstBtn) firstBtn.click();
      });
    }

    modal.classList.add('mskit__variant-modal--open');
    document.body.style.overflow = 'hidden';
  }

  function closeVariantModal() {
    var modal = document.getElementById('mskit-variant-modal');
    if (modal) modal.classList.remove('mskit__variant-modal--open');
    document.body.style.overflow = '';
    variantModalState.slotKey             = null;
    variantModalState.card                = null;
    variantModalState.selectedVariantData = null;
    variantModalState.selectedOptions     = {};
  }

  function renderModalOptions(productData) {
    var optionsContainer = document.getElementById('mskit-variant-modal-options');
    if (!optionsContainer) return;
    optionsContainer.innerHTML = '';

    var options  = productData.options  || [];
    var variants = productData.variants || [];

    options.forEach(function (optionName, idx) {
      var group = document.createElement('div');
      group.className = 'mskit__variant-modal__option-group';

      var label = document.createElement('div');
      label.className = 'mskit__variant-modal__option-label';
      label.textContent = optionName;
      group.appendChild(label);

      var btns = document.createElement('div');
      btns.className = 'mskit__variant-modal__option-btns';

      var optKey = 'opt' + (idx + 1);
      var seen = [];
      variants.forEach(function (v) {
        var val = v[optKey];
        if (val && seen.indexOf(val) === -1) seen.push(val);
      });

      seen.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mskit__variant-modal__option-btn';
        btn.textContent = val;

        btn.addEventListener('click', function () {
          btns.querySelectorAll('.mskit__variant-modal__option-btn').forEach(function (b) {
            b.classList.remove('mskit__variant-modal__option-btn--active');
          });
          this.classList.add('mskit__variant-modal__option-btn--active');

          variantModalState.selectedOptions[idx] = val;

          var matched = findMatchingVariant(variants, variantModalState.numOptions, variantModalState.selectedOptions);
          if (matched) {
            variantModalState.selectedVariantData = matched;
            var imgEl = document.getElementById('mskit-variant-modal-image');
            if (imgEl && matched.image) imgEl.src = matched.image;
            var priceEl = document.getElementById('mskit-variant-modal-price');
            if (priceEl && matched.price) priceEl.textContent = matched.price;
            var confirmBtn = document.getElementById('mskit-variant-modal-confirm');
            if (confirmBtn) confirmBtn.disabled = false;
            var personalizarBtn = document.getElementById('mskit-variant-modal-personalizar');
            if (personalizarBtn && personalizarBtn.style.display !== 'none') personalizarBtn.disabled = false;
          }
        });

        btns.appendChild(btn);
      });

      group.appendChild(btns);
      optionsContainer.appendChild(group);
    });
  }

  function findMatchingVariant(variants, numOptions, selectedOptions) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var idx = 0; idx < numOptions; idx++) {
        if (selectedOptions[idx] !== undefined && v['opt' + (idx + 1)] !== selectedOptions[idx]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function bindVariantModal() {
    var modal = document.getElementById('mskit-variant-modal');
    if (!modal) return;

    var overlay = modal.querySelector('.mskit__variant-modal__overlay');
    if (overlay) overlay.addEventListener('click', closeVariantModal);

    var closeBtn = document.getElementById('mskit-variant-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeVariantModal);

    var confirmBtn = document.getElementById('mskit-variant-modal-confirm');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var vd = variantModalState.selectedVariantData;
        if (!vd) return;
        var overrideData = {
          variantId:    String(vd.id),
          title:        (variantModalState.card && variantModalState.card.dataset.productTitle) || '',
          variantLabel: vd.title || '',
          price:        vd.price || '',
          imageUrl:     vd.image || '',
        };
        onProductSelected(variantModalState.slotKey, variantModalState.card, overrideData);
        closeVariantModal();
      });
    }

    var personalizarBtn = document.getElementById('mskit-variant-modal-personalizar');
    if (personalizarBtn) {
      personalizarBtn.addEventListener('click', function () {
        var vd = variantModalState.selectedVariantData;
        var slotKey = variantModalState.slotKey;
        var card = variantModalState.card;
        if (!vd || !slotKey || !card) return;
        var overrideData = {
          variantId:    String(vd.id),
          title:        card.dataset.productTitle || '',
          variantLabel: vd.title || '',
          price:        vd.price || '',
          imageUrl:     vd.image || '',
        };
        onProductSelected(slotKey, card, overrideData);
        closeVariantModal();
        openPersonalizeDrawer(slotKey);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('mskit__variant-modal--open')) {
        closeVariantModal();
      }
    });
  }

  // =====================================================
  // Step mensagem
  // =====================================================
  function bindMessageStep() {
    var checkbox = document.getElementById('mskit-presente-check');
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        var fields = document.getElementById('mskit-mensagem-fields');
        if (fields) fields.classList.toggle('mskit__message-fields--visible', this.checked);
      });
    }

    var paraInput = document.getElementById('mskit-mensagem-para');
    if (paraInput) {
      paraInput.addEventListener('input', function () { state.mensagem.para = this.value; });
    }

    var textoInput = document.getElementById('mskit-mensagem-texto');
    if (textoInput) {
      textoInput.addEventListener('input', function () { state.mensagem.texto = this.value; });
    }
  }

  // =====================================================
  // Step resumo
  // =====================================================
  function buildSummary() {
    var list = rootEl.querySelector('.mskit__summary-items');
    if (!list) return;
    list.innerHTML = '';

    var kitNameEl = rootEl.querySelector('.mskit__summary-kit-name');
    if (kitNameEl) kitNameEl.textContent = 'Kit: ' + state.kitNome;

    Object.keys(state.selections).forEach(function (key) {
      var sel = state.selections[key];
      if (!sel) return;

      var item = document.createElement('div');
      item.className = 'mskit__summary-item';

      var imgHTML = sel.imageUrl
        ? '<img class="mskit__summary-item-img" src="' + sel.imageUrl + '" alt="' + escapeHTML(sel.title) + '">'
        : '';

      var variantText = sel.variantLabel
        ? '<div class="mskit__summary-item-detail">Variante: ' + escapeHTML(sel.variantLabel) + '</div>'
        : '';

      var ppText = (sel.personalization && sel.personalization.texto)
        ? '<div class="mskit__summary-item-detail">Personalização: ' + escapeHTML(sel.personalization.texto) +
          (sel.personalization.fonte ? ' (' + escapeHTML(sel.personalization.fonte) + ')' : '') + '</div>'
        : '';

      item.innerHTML =
        imgHTML +
        '<div class="mskit__summary-item-info">' +
          '<div class="mskit__summary-item-title">' + escapeHTML(sel.title) + '</div>' +
          variantText +
          ppText +
        '</div>';

      list.appendChild(item);
    });

    if (state.mensagem.texto) {
      var msgItem = document.createElement('div');
      msgItem.className = 'mskit__summary-item';
      msgItem.innerHTML =
        '<div class="mskit__summary-item-info">' +
          '<div class="mskit__summary-item-title">Mensagem presente</div>' +
          '<div class="mskit__summary-item-detail">Para: ' + escapeHTML(state.mensagem.para) +
          ' — ' + escapeHTML(state.mensagem.texto) + '</div>' +
        '</div>';
      list.appendChild(msgItem);
    }
  }

  // =====================================================
  // Drawer de personalização (usa o snippet product-personalize-modal da PDP)
  // =====================================================
  function openPersonalizeDrawer(slotKey) {
    currentPPSlot = slotKey;
    var sel = state.selections[slotKey];
    if (!sel || !sel.productId) return;

    var productId = sel.productId;
    var drawer = document.getElementById('product-personalize-drawer-' + productId);
    if (!drawer) return;

    // Bind único por drawer: captura texto+fonte ao Finalizar
    var finishBtn = drawer.querySelector('#pp-finish');
    if (finishBtn && !finishBtn.dataset.mskitBound) {
      finishBtn.dataset.mskitBound = '1';
      finishBtn.addEventListener('click', function () {
        // O snippet retorna cedo (sem productForm na página do kit),
        // este handler roda depois e salva no estado do kit.
        var slot = currentPPSlot;
        if (!slot || !state.selections[slot]) return;
        var textInput = drawer.querySelector('#pp-text');
        var activeFontBtn = drawer.querySelector('.product-personalizer__font-btn--active');
        var text = textInput ? textInput.value.trim() : '';
        var font = activeFontBtn ? (activeFontBtn.dataset.fontId || '') : '';
        if (text) {
          state.selections[slot].personalization = { texto: text, fonte: font, cor: '#333333' };
        } else {
          state.selections[slot].personalization = null;
        }
        currentPPSlot = null;
        updateNavButtons();
        var closeFn = window['closePersonalizeDrawer_' + productId];
        if (closeFn) closeFn();
      });
    }

    // Abrir com pré-preenchimento se já há personalização salva
    var pp = sel.personalization;
    if (pp && pp.texto) {
      var fromCartFn = window['openPersonalizeDrawerFromCart_' + productId];
      if (fromCartFn) { fromCartFn({ text: pp.texto, font: pp.fonte }); return; }
    }
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    var openFn = window['openPersonalizeDrawer_' + productId];
    if (openFn) openFn();
  }

  // =====================================================
  // Submissão ao carrinho
  // =====================================================
  function submitToCart() {
    var nextBtn = document.getElementById('mskit-next-btn');
    if (nextBtn) nextBtn.disabled = true;

    var loadingEl = rootEl.querySelector('.mskit__loading');
    if (loadingEl) loadingEl.classList.add('mskit__loading--visible');

    var kitInstanceId = 'kit-' + Date.now().toString(36).slice(-4);

    var items = Object.keys(state.selections).map(function (key) {
      var sel = state.selections[key];
      if (!sel || !sel.variantId) return null;

      var properties = {
        '_kit_id': kitInstanceId,
        '_kit_nome': state.kitNome,
      };

      if (sel.personalization && sel.personalization.texto && sel.personalization.texto.trim()) {
        properties['_Personalização'] = 'Sim';
        properties['Texto'] = sel.personalization.texto.trim();
        properties['Fonte'] = sel.personalization.fonte || '';
        properties['_PersonalizaçãoID'] = Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 9);
        properties['_Cor'] = sel.personalization.cor || '#333333';
      }

      if (state.mensagem.texto && state.mensagem.texto.trim()) {
        properties['_Kit_Mensagem_Para'] = state.mensagem.para;
        properties['_Kit_Mensagem'] = state.mensagem.texto;
      }

      return {
        id: parseInt(sel.variantId, 10),
        quantity: 1,
        properties: properties,
      };
    }).filter(Boolean);

    if (!items.length) {
      alert('Nenhum item selecionado.');
      if (nextBtn) nextBtn.disabled = false;
      if (loadingEl) loadingEl.classList.remove('mskit__loading--visible');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Erro ao adicionar.');
        var redirect = function() { window.location.href = '/cart'; };
        if (window.syncPersonalizationNote) {
          window.syncPersonalizationNote().then(redirect).catch(redirect);
        } else {
          redirect();
        }
      })
      .catch(function (err) {
        console.error('[Monte Seu Kit]', err);
        alert('Erro ao adicionar ao carrinho. Tente novamente.');
        if (nextBtn) nextBtn.disabled = false;
        if (loadingEl) loadingEl.classList.remove('mskit__loading--visible');
      });
  }

  // =====================================================
  // Utilitários de fonte
  // =====================================================
  var loadedFonts = {};

  var fontConfigs = {
    arial:            { family: 'Arial' },
    calibri:          { family: 'Calibri' },
    montserrat:       { family: 'Montserrat',        href: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap' },
    bebas:            { family: 'Bebas Neue',         href: 'https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap' },
    graduate:         { family: 'Graduate',           href: 'https://fonts.googleapis.com/css2?family=Graduate&display=swap' },
    playfair:         { family: 'Playfair Display',   href: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600&display=swap' },
    caprasimo:        { family: 'Caprasimo',          href: 'https://fonts.googleapis.com/css2?family=Caprasimo&display=swap' },
    script:           { family: 'Great Vibes',        href: 'https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap' },
    serif:            { family: 'Times New Roman' },
    sans:             { family: 'Poppins' },
    monotype_corsiva: { family: 'Monotype Corsiva' },
  };

  function getFontCSS(id) {
    var cfg = fontConfigs[id] || { family: 'Poppins' };
    return '"' + cfg.family + '", sans-serif';
  }

  function ensureFontLoaded(id, callback) {
    if (loadedFonts[id]) {
      if (callback) callback();
      return;
    }
    var cfg = fontConfigs[id];
    if (!cfg || !cfg.href) {
      loadedFonts[id] = true;
      if (callback) callback();
      return;
    }
    var linkId = 'mskit-font-' + id;
    if (!document.getElementById(linkId)) {
      var link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href = cfg.href;
      document.head.appendChild(link);
    }
    if (document.fonts && document.fonts.load) {
      Promise.race([
        document.fonts.load('16px "' + cfg.family + '"'),
        new Promise(function (resolve) { setTimeout(resolve, 2000); }),
      ]).then(function () {
        loadedFonts[id] = true;
        if (callback) callback();
      }).catch(function () {
        loadedFonts[id] = true;
        if (callback) callback();
      });
    } else {
      setTimeout(function () {
        loadedFonts[id] = true;
        if (callback) callback();
      }, 500);
    }
  }

  // =====================================================
  // Helpers
  // =====================================================
  function removeEmojis(str) {
    return str.replace(/[\u{1F300}-\u{1F9FF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FAFF}]|[\u{FE00}-\u{FE0F}]|[\u{200D}]/gu, '')
      .replace(/[\u{1F1E0}-\u{1F1FF}]/gu, '');
  }

  function escapeHTML(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  // =====================================================
  // Arranque
  // =====================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
